import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServicesComponent } from './services.component';

const routes: Routes = [
  { path: '', component: ServicesComponent },
  // { path: 'debt-management', loadChildren: () => import('./service-pages/debt/debt.module').then(m => m.DebtModule) },
  { path: 'fundraising', loadChildren: () => import('./service-pages/fundraising/fundraising.module').then(m => m.FundraisingModule) },

  { path: 'energy', loadChildren: () => import('./service-pages/domestic/domestic.module').then(m => m.DomesticModule) },
  { path: 'insurance', loadChildren: () => import('./service-pages/insurance/insurance.module').then(m => m.InsuranceModule) },

  //We're showing broadband contracts in mobile contract page, broadband module added but not used
  // { path: 'mobile-contracts', loadChildren: () => import('./service-pages/mobile-contracts/mobile-contracts.module').then(m => m.MobileContractsModule) },
  { path: 'broadband-contracts', loadChildren: () => import('./service-pages/mobile-contracts/mobile-contracts.module').then(m => m.MobileContractsModule) },
  { path: 'solar-panel', loadChildren: () => import('./service-pages/solar-panel/solar-panel.module').then(m => m.SolarPanelModule) }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServicesRoutingModule { }
